import React, { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => JSON.parse(localStorage.getItem("nl_cart") || "[]"));
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem("nl_cart", JSON.stringify(items)); }, [items]);

  const add = (item) => {
    setItems((prev) => {
      const key = (i) => `${i.product_id}-${i.size}-${i.color}`;
      const idx = prev.findIndex((i) => key(i) === key(item));
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + (item.quantity || 1) };
        return copy;
      }
      return [...prev, { ...item, quantity: item.quantity || 1 }];
    });
    setOpen(true);
  };
  const remove = (i) => setItems((p) => p.filter((_, idx) => idx !== i));
  const setQty = (i, q) => setItems((p) => p.map((it, idx) => idx === i ? { ...it, quantity: Math.max(1, q) } : it));
  const clear = () => setItems([]);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, add, remove, setQty, clear, subtotal, count, open, setOpen }}>
      {children}
    </CartCtx.Provider>
  );
}
